import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "./pages/Login";

import TeacherDashboard from "./pages/TeacherDashboard";

import AdminDashboard from "./pages/AdminDashboard";

import MyAssignments from "./pages/MyAssignments";

import ProtectedRoute from "./components/ProtectedRoute";

import EnterMarks from "./pages/EnterMarks";

import AdminReports from "./pages/AdminReports";

import AdminFees from "./pages/AdminFees";

import AttendanceEntry from "./pages/AttendanceEntry";

import AdminIDCards from "./pages/AdminIDCards";

import AdminClassLists from "./pages/AdminClassLists";
import AdminAssessmentRegister from "./pages/AdminAssessmentRegister";

/* NEW */
import AdminClassAnalytics from "./pages/AdminClassAnalytics";

import SendReportCards from "./pages/SendReportCards";

import SendParentMessages from "./pages/SendParentMessages";

import StudentDashboard from "./pages/StudentDashboard";

import PreStudentDashboard from "./pages/PreStudentDashboard";

import UploadFeeProof from "./pages/UploadFeeProof";

import MySubjects from "./pages/MySubjects";
import AdminInstallments from "./pages/AdminInstallments";
import DeanClasses from "./pages/DeanClasses";
import DeanStudents
from "./pages/DeanStudents";



function App() {

  return (

    <BrowserRouter>

      <Routes>

        {/* ===================================================== */}
        {/* PUBLIC */}
        {/* ===================================================== */}

        <Route
          path="/"
          element={<Login />}
        />


        {/* ===================================================== */}
        {/* TEACHER */}
        {/* ===================================================== */}

        <Route
          path="/teacher-dashboard"
          element={
            <ProtectedRoute roleRequired="TEACHER">
              <TeacherDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/teacher/my-assignments"
          element={
            <ProtectedRoute roleRequired="TEACHER">
              <MyAssignments />
            </ProtectedRoute>
          }
        />

        <Route
  path="/dean/students/:classId"
  element={<DeanStudents />}
/>

        <Route
          path="/teacher/enter-marks/:assignmentId"
          element={
            <ProtectedRoute roleRequired="TEACHER">
              <EnterMarks />
            </ProtectedRoute>
          }
        />

        <Route
          path="/teacher/attendance/:assignmentId"
          element={
            <ProtectedRoute roleRequired="TEACHER">
              <AttendanceEntry />
            </ProtectedRoute>
          }
        />


        {/* ===================================================== */}
        {/* ADMIN */}
        {/* ===================================================== */}

        <Route
          path="/admin-dashboard"
          element={
            <ProtectedRoute roleRequired="ADMIN">
              <AdminDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/reports"
          element={
            <ProtectedRoute roleRequired="ADMIN">
              <AdminReports />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/fees"
          element={
            <ProtectedRoute roleRequired="ADMIN">
              <AdminFees />
            </ProtectedRoute>
          }
        />

        <Route
  path="/admin/installments"
  element={
    <ProtectedRoute roleRequired="ADMIN">
      <AdminInstallments />
    </ProtectedRoute>
  }
/>

<Route
  path="/dean/classes"
  element={<DeanClasses />}
/>

        <Route
          path="/admin/id-cards"
          element={
            <ProtectedRoute roleRequired="ADMIN">
              <AdminIDCards />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/class-lists"
          element={
            <ProtectedRoute roleRequired="ADMIN">
              <AdminClassLists />
            </ProtectedRoute>
          }
        />

        {/* ===================================================== */}
        {/* CLASS ANALYTICS */}
        {/* ===================================================== */}

        <Route
          path="/admin/class-analytics"
          element={
            <ProtectedRoute roleRequired="ADMIN">
              <AdminClassAnalytics />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin-assessment-register"
          element={
            <ProtectedRoute roleRequired="ADMIN">
              <AdminAssessmentRegister />
            </ProtectedRoute>
          }
        />


        {/* ===================================================== */}
{/* COMMUNICATION CENTER */}
{/* ===================================================== */}

        <Route
          path="/admin/send-report-cards"
          element={
            <ProtectedRoute roleRequired="ADMIN">
              <SendReportCards />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/send-parent-messages"
          element={
            <ProtectedRoute roleRequired="ADMIN">
              <SendParentMessages />
            </ProtectedRoute>
          }
        />


        {/* ===================================================== */}
        {/* STUDENT HOME */}
        {/* ===================================================== */}

        <Route
          path="/student-home"
          element={
            <ProtectedRoute roleRequired="STUDENT">
              <PreStudentDashboard />
            </ProtectedRoute>
          }
        />


        {/* ===================================================== */}
        {/* STUDENT RESULTS */}
        {/* ===================================================== */}

        <Route
          path="/student-dashboard"
          element={
            <ProtectedRoute roleRequired="STUDENT">
              <StudentDashboard />
            </ProtectedRoute>
          }
        />


        {/* ===================================================== */}
        {/* STUDENT SUBJECTS */}
        {/* ===================================================== */}

        <Route
          path="/my-subjects"
          element={
            <ProtectedRoute roleRequired="STUDENT">
              <MySubjects />
            </ProtectedRoute>
          }
        />


        {/* ===================================================== */}
        {/* UPLOAD PAYMENT */}
        {/* ===================================================== */}

        <Route
          path="/upload-fee-proof"
          element={
            <ProtectedRoute roleRequired="STUDENT">
              <UploadFeeProof />
            </ProtectedRoute>
          }
        />

      </Routes>

    </BrowserRouter>
  );
}

export default App;